import { compose, withHandlers, withStateHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';
import { addProps } from 'utils/recompose';
import {
  addAdvancedFilter,
  deleteAdvancedFilter,
  fetchModelAdvancedWithFilters,
} from 'reducers/modelAdvanced/actions';
import { advancedFilters } from 'reducers/modelAdvanced/selectors';
import styles from './styles.module.scss';

export const initialState = { filterOn: false };

export const toggleFilter = ({ filterOn }) => () => ({
  filterOn: !filterOn,
});

export const resetFilter = () => () => initialState;

const formatFilters = advancedFilters => {
  let filterStrings = [];
  Object.keys(advancedFilters).map(
    key =>
      advancedFilters[key].length > 0 &&
      advancedFilters[key].map(code => filterStrings.push(`${key}=${code}`)),
  );
  return filterStrings.join('&');
};

export const hasNoFilters = ({ advancedFilters }) =>
  Object.values(advancedFilters).flatten().length === 0;

export function componentDidUpdate(prevProps) {
  const { modelId, resetFilter, hasNoFilters } = this.props;
  if (prevProps.modelId !== modelId && prevProps.filterOn) {
    resetFilter();
  }
  if (hasNoFilters && prevProps.filterOn) {
    resetFilter();
  }
}

export const updateChartWithFilter = ({
  modelId,
  addAdvancedFilter,
  deleteAdvancedFilter,
  toggleFilter,
  fetchModelAdvancedWithFilters,
  advancedFilters,
  filterOn,
  count,
}) => (filterType, code) => {
  if (count === 0) return;
  toggleFilter();
  if (filterOn) {
    deleteAdvancedFilter({ filterType: filterType, code: code });
  } else {
    addAdvancedFilter({ filterType: filterType, code: code });
  }
  fetchModelAdvancedWithFilters({
    modelId: modelId,
    filters: formatFilters(advancedFilters),
  });
};

export const filterTypeStyle = ({ filterType }) => {
  if (filterType === 'priceBands') {
    return { width: '213px' };
  } else if (filterType === 'functionalOptions') {
    return { width: '90px', marginRight: '20px', padding: '0 8px' };
  } else {
    return { width: '140px' };
  }
};

export const buttonStyle = ({ count, filterOn }) => {
  if (count === 0) {
    return styles.zeroFilter;
  } else if (filterOn) {
    return styles.activeFilter;
  } else {
    return styles.inactiveFilter;
  }
};

const mapStateToProps = combineSelectors({
  advancedFilters,
});

export default compose(
  connect(mapStateToProps, {
    addAdvancedFilter,
    deleteAdvancedFilter,
    fetchModelAdvancedWithFilters,
  }),
  withStateHandlers(initialState, {
    toggleFilter,
    resetFilter,
  }),
  addProps({
    filterTypeStyle,
    buttonStyle,
    hasNoFilters,
  }),
  withHandlers({
    updateChartWithFilter,
  }),
  lifecycle({ componentDidUpdate }),
);
